import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';


const BotonAtrasSiguienteComponent = (props) => {

    const { botonSiguiente, botonAnterior, paginaActiva, totalDePaginas, valores } = props
    const paginaSiguiente = () => {
        botonSiguiente(valores)
    }
    const paginaAnterior = () => {
        botonAnterior()
    }
    return (
        <Fragment>
            <div className='text-center'>
                <ButtonGroup disableElevation variant="contained" color='inherit'>
                    {
                        paginaActiva === 1 ?
                            <Button
                                style={{ backgroundColor: '#D9A563', color: 'white' }}
                                onClick={() => paginaAnterior()}
                                disabled={true}
                            >
                                Atrás
                            </Button>
                            :
                            <Button
                                style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                onClick={() => paginaAnterior()}
                            >
                                Atrás
                            </Button>
                    }
                    {
                        paginaActiva === totalDePaginas ?
                            <Button
                                style={{ backgroundColor: '#D9A563', color: 'white' }}
                                onClick={() => paginaSiguiente()}
                                disabled={true}
                            >
                                Siguiente
                            </Button>
                            :
                            <Button
                                style={{ backgroundColor: '#c88b3e', color: 'white' }}
                                onClick={() => paginaSiguiente()}
                                type='submit'
                            >
                                Siguiente
                            </Button>

                    }

                </ButtonGroup>
            </div>
        </Fragment>
    )
};

export default withRouter(BotonAtrasSiguienteComponent)
